import React from 'react'
import { StyledBookPlaceholder, Cover, Info } from './BookPlaceholder.styles'

const BookPlaceholder = ({
  height = undefined,
  width = undefined,
  minHeight = undefined,
  hasInfosPlaceholder = undefined,
  responsive = undefined,
  ...rest
}) => {
  return (
    <StyledBookPlaceholder
      width={width}
      minHeight={minHeight}
      height={height}
      responsive={responsive}
      {...rest}
    >
      <Cover
        width={width}
        height={height}
        minHeight={minHeight}
        responsive={responsive}
      />
      {hasInfosPlaceholder && (
        <React.Fragment>
          <Info width="100%" />
          <Info width="70%" />
        </React.Fragment>
      )}
    </StyledBookPlaceholder>
  )
}

BookPlaceholder.defaultProps = {
  hasInfosPlaceholder: true
}

export default BookPlaceholder
